import "./datatables.scss"
import React from 'react'
import { Component } from 'react'

const $ = require('jquery')
$.DataTable = require('datatables.net')

export class AddFacilityVariable extends Component{

    componentDidMount(){

       this.$el = $(this.el);
       this.$el.DataTable({
        data: this.props.dataInfo,
        columns: [
            { title: 'NUM' },
            { title: 'Name' },
            { title: 'NB' },
            { title: 'UI' },
            { title: 'CN' },
            { title: 'HIDE' },
        ]
       })
    }

    componentWillUnmount(){
        this.$el.DataTable.destroy(true)
    }

    render() {
        return <div>
            <table className='display' width="100%" ref={el => this.el = el}  ></table>
        </div>
    }
}

export default AddFacilityVariable;